import { BackendQnAParams } from '../../QnAConfigModal/services/types';

export interface AIMessage {
  role: 'user' | 'assistant' | 'system';
  content: string;
}

export interface AIResponse {
  content: string;
  usage?: {
    promptTokens: number;
    completionTokens: number;
    totalTokens: number;
  };
}

export interface AIServiceConfig {
  apiKey?: string;
  model?: string;
  maxTokens?: number;
  temperature?: number;
  timeout?: number;
  systemPrompt?: string;
  overrideParams?: BackendQnAParams;
}

export interface AIService {
  generateResponse(messages: AIMessage[], context?: string): Promise<AIResponse>;
  validateConfig(): boolean;
  getProviderName(): string;
}

export interface StreamingAIResponse {
  content: string;
  isComplete: boolean;
  usage?: {
    promptTokens: number;
    completionTokens: number;
    totalTokens: number;
  };
}

export interface StreamingAIService extends AIService {
  generateStreamingResponse(
    messages: AIMessage[],
    context?: string,
    onChunk?: (chunk: StreamingAIResponse) => void
  ): Promise<AIResponse>;
}

export class AIServiceError extends Error {
  constructor(
    message: string,
    public code: string,
    public retryable: boolean = false,
  ) {
    super(message);
    this.name = 'AIServiceError';
  }
}

export interface PromptBuilder {
  buildSystemPrompt(context: string): string;
}
